import CategoryOptions from './CategoryOptions'

export default CategoryOptions
